module.exports = __webpack_public_path__ + "static/media/Approved.15336653.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Approved.svg
// module id = 495
// module chunks = 17